import { getConfig } from '@tcs/client-portal/config/configService';
import axios from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { useOktaAuth } from '@okta/okta-react';
import { EsignConsentStatus } from '@tcs/client-portal-api/platform_generated';

export const useEsignConsentStatusMutation = (accountId: string) => {
  const { oktaAuth } = useOktaAuth();
  const queryClient = useQueryClient();

  return useMutation(async (EsignConsentStatus: EsignConsentStatus) => {
    const config = getConfig();
    const tokens = await oktaAuth.tokenManager.getTokens();
    const token = tokens.accessToken?.accessToken;
    await axios.put(
      `${config.API_BASE_URL}/accounts/${accountId}/EsignConsentStatus`,
      EsignConsentStatus,
      {
        headers: {
          'Content-Type': 'text/plain',
          'x-tcs-authorization': token,
        },
      }
    );
    await queryClient.refetchQueries({
      predicate: (query) =>
        query.queryKey.toString().includes('/EsignConsentStatus'),
    });
  });
};
